import React, { useState } from "react";
import { ConLogoDark, LabLogoDark } from "../../Utils/images";
import Heading from "../Common/Heading";
import Loader from "../Common/Loader";

const LandingPage = () => {
  const [loading, setLoading] = useState(0);

  return loading === 2 ? (
    <Loader>
      {loading === 0 && (
        <img
          src={LabLogoDark}
          alt='scour'
          style={{ display: "none" }}
          onLoad={() => setLoading(1)}
        />
      )}
      {loading === 1 && (
        <img
          src={ConLogoDark}
          alt='scour'
          style={{ display: "none" }}
          onLoad={() => setLoading(2)}
        />
      )}
    </Loader>
  ) : (
    <div className='landing-page'>
      <div className='landing-page-inner-block'>
        <Heading heading='SCOUR' fontSize='19vw' useDarkColorFont />

        <div className='landing-page-content'>
          <div
            className='landing-page-images'
            onClick={() => window.open(process.env.REACT_APP_CONSTRUCTION_URL)}
          >
            <img src={ConLogoDark} alt='scour construction' />
          </div>

          <div className='y-line' />

          <div
            className='landing-page-images'
            onClick={() => window.open(process.env.REACT_APP_LABORATORY_URL)}
          >
            <img src={LabLogoDark} alt='scour laboratory' />
          </div>
        </div>
      </div>

      <div className='landing-page-footer light-mode'>
        <p>© SCOUR 2024. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default LandingPage;
